var _ellipse, _ellipse2, _ellipse3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotivation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 196,
    viewBox: "0 0 195 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 97.5772,
    rx: 96.9021,
    ry: 97.0772,
    stroke: "#F35C6B",
    strokeOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 101.076,
    rx: 77.2977,
    ry: 77.4374,
    stroke: "#F35C6B",
    strokeOpacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 101.076,
    rx: 57.7293,
    ry: 57.8336,
    stroke: "#F35C6B",
    strokeOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14933_19224)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.261 78.4843L94.504 70.7192L101.537 79.9344L113.056 88.1179L107.261 78.4843Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.261 78.4843L94.504 70.7192L101.537 79.9344L113.056 88.1179L107.261 78.4843Z",
    fill: "url(#paint0_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.806 61.7703L125.331 62.323L118.173 71.0808L130.806 61.7703Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.411 62.1111L117.9 71.1147L124.964 62.2933L116.411 62.1111Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.411 62.1111L117.9 71.1147L124.964 62.2933L116.411 62.1111Z",
    fill: "url(#paint1_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter4_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.687 62.2493L97.4257 62.4841L104.603 74.0673L118.214 71.4123L116.687 62.2493Z",
    fill: "#BB8AFF",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.687 62.2493L97.4257 62.4841L104.603 74.0673L118.214 71.4123L116.687 62.2493Z",
    fill: "url(#paint2_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.687 62.2493L97.4257 62.4841L104.603 74.0673L118.214 71.4123L116.687 62.2493Z",
    fill: "url(#paint3_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.687 62.2493L97.4257 62.4841L104.603 74.0673L118.214 71.4123L116.687 62.2493Z",
    fill: "url(#paint4_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.687 62.2493L97.4257 62.4841L104.603 74.0673L118.214 71.4123L116.687 62.2493Z",
    fill: "url(#paint5_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.687 62.2493L97.4257 62.4841L104.603 74.0673L118.214 71.4123L116.687 62.2493Z",
    fill: "url(#paint6_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.4077 62.3391L108.158 48.6916L120.784 60.3268L116.159 62.142L97.4077 62.3391Z",
    fill: "#BB8AFF",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.4077 62.3391L108.158 48.6916L120.784 60.3268L116.159 62.142L97.4077 62.3391Z",
    fill: "url(#paint7_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.791 61.6496L108.192 48.6875L121.004 60.2525L130.791 61.6496Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter7_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.074 60.2232L116.403 62.0494L125.211 62.2128L130.791 61.6495L121.074 60.2232Z",
    fill: "#BB8AFF",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.72 73.7357L113.186 88.102L118.173 71.0809L104.72 73.7357Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.72 73.7357L113.186 88.102L118.173 71.0809L104.72 73.7357Z",
    fill: "url(#paint8_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter9_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.991 71.2692L130.791 61.6496L123.933 79.6914L113.056 88.118L117.991 71.2692Z",
    fill: "#BB8AFF",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.051 71.4253L130.791 61.6496L123.933 79.6914L113.056 88.118L118.051 71.4253Z",
    fill: "url(#paint9_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.051 71.4253L130.791 61.6496L123.933 79.6914L113.056 88.118L118.051 71.4253Z",
    fill: "url(#paint10_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter10_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.256 78.3336L94.5006 70.6909L97.4348 62.4829L104.576 73.9315L107.256 78.3336Z",
    fill: "#BB8AFF",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.256 78.3336L94.5006 70.6909L97.4348 62.4829L104.576 73.9315L107.256 78.3336Z",
    fill: "url(#paint11_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0813 125.107L113.536 137.534L156.751 112.101L123.877 100.619L84.0813 125.107Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.0813 125.107L113.536 137.534L156.751 112.101L123.877 100.619L84.0813 125.107Z",
    fill: "url(#paint12_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0813 125.107L113.536 137.534L156.751 112.101L123.877 100.619L84.0813 125.107Z",
    fill: "url(#paint13_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0813 125.107L113.536 137.534L156.751 112.101L123.877 100.619L84.0813 125.107Z",
    fill: "url(#paint14_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter13_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.209 149.744L112.868 138.044L83.632 125.62L82.1882 127.27L105.094 154.222L119.209 149.744Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.209 149.744L112.868 138.044L83.632 125.62L82.1882 127.27L105.094 154.222L119.209 149.744Z",
    fill: "url(#paint15_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.104 131.025L127.47 142.056L119.305 149.807L112.888 137.708L124.104 131.025Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.104 131.025L127.47 142.056L119.305 149.807L112.888 137.708L124.104 131.025Z",
    fill: "url(#paint16_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.104 131.025L127.47 142.056L119.305 149.807L112.888 137.708L124.104 131.025Z",
    fill: "url(#paint17_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter15_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.127 111.555L162.066 120.144L149.318 146.853L127.127 141.331L123.728 130.575L156.127 111.555Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.127 111.555L162.066 120.144L149.318 146.853L127.127 141.331L123.728 130.575L156.127 111.555Z",
    fill: "url(#paint18_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.127 111.555L162.066 120.144L149.318 146.853L127.127 141.331L123.728 130.575L156.127 111.555Z",
    fill: "url(#paint19_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter16_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.219 149.732L144.118 152.794L149.263 146.916L127.292 142.016L119.219 149.732Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter17_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.793 153.96L126.81 157.47L140.429 155.6L143.948 152.989L119.026 149.343L104.793 153.96Z",
    fill: "#D48DD6",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M104.793 153.96L126.81 157.47L140.429 155.6L143.948 152.989L119.026 149.343L104.793 153.96Z",
    fill: "url(#paint20_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.219 149.732L144.118 152.794L149.263 146.916L127.292 142.016L119.219 149.732Z",
    fill: "url(#paint21_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M156.103 111.534L162.01 120.111L152.744 139.438L123.669 130.643L156.103 111.534Z",
    fill: "url(#paint22_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter19_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4556 87.5589L45.8893 81.1481L71.778 80.4723L74.1103 100.583L48.4556 87.5589Z",
    fill: "#F35C81",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.4556 87.5589L45.8893 81.1481L71.778 80.4723L74.1103 100.583L48.4556 87.5589Z",
    fill: "url(#paint23_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter20_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2906 102.326L73.6228 100.552L71.4839 80.3206L85.2906 102.326Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.2906 102.326L73.6228 100.552L71.4839 80.3206L85.2906 102.326Z",
    fill: "url(#paint24_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter21_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2791 116.171L48.4933 87.8042L73.6973 100.59L73.5189 125.128L49.2791 116.171Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.2791 116.171L48.4933 87.8042L73.6973 100.59L73.5189 125.128L49.2791 116.171Z",
    fill: "url(#paint25_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.2791 116.171L48.4933 87.8042L73.6973 100.59L73.5189 125.128L49.2791 116.171Z",
    fill: "url(#paint26_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter22_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1997 102.502L73.9564 100.881L73.71 124.757L85.1997 102.502Z",
    fill: "#F35C6B",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.1997 102.502L73.9564 100.881L73.71 124.757L85.1997 102.502Z",
    fill: "url(#paint27_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter23_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.36 87.5097L34.0123 104.154L49.4285 115.242L48.36 87.5097Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter24_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8679 81.1895L33.9678 104.24L48.5713 87.6528L45.8679 81.1895Z",
    fill: "#FF5E80",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter25_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8984 126.016L49.2237 115.639L73.71 124.758L46.8984 126.016Z",
    fill: "#BB8AFF",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.8984 126.016L49.2237 115.639L73.71 124.758L46.8984 126.016Z",
    fill: "url(#paint28_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter26_i_14933_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9679 104.24L49.3523 115.442L46.8889 126.011L33.9679 104.24Z",
    fill: "#BB8AFF",
    fillOpacity: 0.02
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.9679 104.24L49.3523 115.442L46.8889 126.011L33.9679 104.24Z",
    fill: "url(#paint29_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9683 105.944L33.9875 104.202L49.4285 115.242L48.9683 105.944Z",
    fill: "url(#paint30_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2791 116.171L48.4933 87.8042L73.6973 100.59L73.5189 125.128L49.2791 116.171Z",
    fill: "url(#paint31_linear_14933_19224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2791 116.171L48.4933 87.8042L73.6973 100.59L73.5189 125.128L49.2791 116.171Z",
    fill: "url(#paint32_linear_14933_19224)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14933_19224",
    x: 94.504,
    y: 70.7192,
    width: 18.5521,
    height: 17.3987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.63208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_14933_19224",
    x: 118.173,
    y: 61.7703,
    width: 12.6326,
    height: 9.31055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.63208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_14933_19224",
    x: 116.411,
    y: 62.1111,
    width: 8.55359,
    height: 9.00366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.63208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_14933_19224",
    x: 97.4257,
    y: 62.2493,
    width: 20.7885,
    height: 11.8181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.63208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_14933_19224",
    x: 97.4077,
    y: 48.6917,
    width: 23.3763,
    height: 13.6475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.63208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_14933_19224",
    x: 108.192,
    y: 48.6875,
    width: 22.5985,
    height: 12.9622,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.64185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_14933_19224",
    x: 116.403,
    y: 60.2231,
    width: 14.3879,
    height: 1.98975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.63208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_14933_19224",
    x: 104.72,
    y: 71.0808,
    width: 13.4535,
    height: 17.0212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.63254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_14933_19224",
    x: 113.056,
    y: 61.6497,
    width: 17.7346,
    height: 26.4683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.63208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_14933_19224",
    x: 94.5006,
    y: 62.4829,
    width: 12.755,
    height: 15.8506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.63208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_14933_19224",
    x: 84.0813,
    y: 100.619,
    width: 72.6702,
    height: 36.9148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.20594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_14933_19224",
    x: 82.1882,
    y: 125.62,
    width: 37.0204,
    height: 28.6023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.82304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_14933_19224",
    x: 112.888,
    y: 131.025,
    width: 14.5815,
    height: 18.7822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.82304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_14933_19224",
    x: 123.728,
    y: 111.554,
    width: 38.3372,
    height: 35.2988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.82304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_14933_19224",
    x: 119.219,
    y: 142.016,
    width: 30.0439,
    height: 10.7776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.82304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_14933_19224",
    x: 104.793,
    y: 149.343,
    width: 39.1543,
    height: 8.12646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.82304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.552941 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_14933_19224",
    x: 45.8893,
    y: 80.4722,
    width: 28.2209,
    height: 20.1104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.16137
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.360784 0 0 0 0 0.505882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_14933_19224",
    x: 71.4839,
    y: 80.3206,
    width: 13.8066,
    height: 22.0054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.16137
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_14933_19224",
    x: 48.4933,
    y: 87.8042,
    width: 25.204,
    height: 37.3237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.05066
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_14933_19224",
    x: 73.71,
    y: 100.881,
    width: 11.4897,
    height: 23.8767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.16137
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_14933_19224",
    x: 34.0123,
    y: 87.5098,
    width: 15.4161,
    height: 27.7322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.16137
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_14933_19224",
    x: 33.9679,
    y: 81.1895,
    width: 14.6034,
    height: 23.0505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.16137
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_i_14933_19224",
    x: 46.8984,
    y: 115.639,
    width: 26.8115,
    height: 10.3774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.16137
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_i_14933_19224",
    x: 33.9679,
    y: 104.24,
    width: 15.3844,
    height: 21.771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.16137
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14933_19224",
    x1: 115.974,
    y1: 87.4465,
    x2: 99.4411,
    y2: 83.8602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14933_19224",
    x1: 120.142,
    y1: 72.8987,
    x2: 124.656,
    y2: 57.0509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14933_19224",
    x1: 81.9545,
    y1: 103.064,
    x2: 109.733,
    y2: 62.0401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4599",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14933_19224",
    x1: 121.343,
    y1: 41.2446,
    x2: 102.892,
    y2: 66.5854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CAD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14933_19224",
    x1: 78.45,
    y1: 45.19,
    x2: 106.125,
    y2: 72.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA1CE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14933_19224",
    x1: 94.3039,
    y1: 82.6478,
    x2: 105.01,
    y2: 64.2108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA1CE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14933_19224",
    x1: 124.619,
    y1: 52.5242,
    x2: 102.274,
    y2: 63.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4599",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14933_19224",
    x1: 92.2188,
    y1: 61.9239,
    x2: 109.48,
    y2: 45.3275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF65AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14933_19224",
    x1: 119.616,
    y1: 71.0489,
    x2: 112.513,
    y2: 88.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14933_19224",
    x1: 129.265,
    y1: 91.1197,
    x2: 114.731,
    y2: 81.9022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65E99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14933_19224",
    x1: 153.284,
    y1: 52.2653,
    x2: 118.411,
    y2: 72.5449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14933_19224",
    x1: 84.8466,
    y1: 48.4848,
    x2: 98.0793,
    y2: 70.8597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4599",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14933_19224",
    x1: 145.429,
    y1: 117.114,
    x2: 74.1889,
    y2: 124.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14933_19224",
    x1: 60.0952,
    y1: 121.462,
    x2: 120.144,
    y2: 145.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4599",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14933_19224",
    x1: 152.059,
    y1: 193.819,
    x2: 129.032,
    y2: 116.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14933_19224",
    x1: 94.636,
    y1: 141.45,
    x2: 105.429,
    y2: 189.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14933_19224",
    x1: 124.876,
    y1: 145.779,
    x2: 120.958,
    y2: 116.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14933_19224",
    x1: 120.038,
    y1: 160.355,
    x2: 130.218,
    y2: 129.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4599",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14933_19224",
    x1: 173.415,
    y1: 163.163,
    x2: 141.603,
    y2: 125.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF65AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14933_19224",
    x1: 173.415,
    y1: 163.163,
    x2: 141.603,
    y2: 125.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF65AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14933_19224",
    x1: 115.191,
    y1: 163.06,
    x2: 150.888,
    y2: 161.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA1CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14933_19224",
    x1: 107.969,
    y1: 125.887,
    x2: 157.251,
    y2: 152.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_14933_19224",
    x1: 168.891,
    y1: 162.163,
    x2: 144.346,
    y2: 115.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA1CE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14933_19224",
    x1: 63.0014,
    y1: 79.4115,
    x2: 62.327,
    y2: 101.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14933_19224",
    x1: 84.5015,
    y1: 75.5056,
    x2: 73.692,
    y2: 94.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_14933_19224",
    x1: 64.9304,
    y1: 103.594,
    x2: 32.1511,
    y2: 127.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4599",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_14933_19224",
    x1: 56.6301,
    y1: 114.851,
    x2: 110.575,
    y2: 132.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4599",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_14933_19224",
    x1: 70.4617,
    y1: 95.06,
    x2: 76.4633,
    y2: 114.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4599",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_14933_19224",
    x1: 61.0687,
    y1: 121.364,
    x2: 39.169,
    y2: 134.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_14933_19224",
    x1: 38.5885,
    y1: 128.98,
    x2: 10.3281,
    y2: 88.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65E99",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_14933_19224",
    x1: 57.279,
    y1: 99.4663,
    x2: 43.3189,
    y2: 110.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_14933_19224",
    x1: 67.2215,
    y1: 121.332,
    x2: 48.0972,
    y2: 88.2317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_14933_19224",
    x1: 64.1511,
    y1: 112.817,
    x2: 69.9984,
    y2: 88.5332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14933_19224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white",
    transform: "translate(35.9023 39.1313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivation);
export default __webpack_public_path__ + "static/media/Motivation.ee8a8bfe7fe325c2720a484f31474a46.svg";
export { ForwardRef as ReactComponent };